import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { FormInput, FormInputMultiline } from 'elements/Inputs/FormInput/';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { selectFailureModeSectionData } from './FailureModeSection.data';
import { StyledLabelTab, StyleFailureNewDropdown } from './FailureModeSection.styled';

const FailureModeSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly, userRole } = props;

    const multiDrop = (field) => field.isMultiline ? (
        <FormInputMultiline
            rows={3}
            id={field.key}
            name={field.key}
            label={field.label}
            value={field.value}
            isRequired={field.isRequired}
            handleChange={changeHandler}
            width={field.width}
            inputWidth={field.inputWidth}
            marginLeft={field.marginLeft}
            readOnly={field.readOnly || isFormReadOnly}
            alignItems={field.alignItems}
            padding={field.padding}
            marginTop={field.marginTop}
            marginBottom={field.marginBottom}
            marginRight={field.marginRight}
            isDisabled={field.isDisabled}
            borderRight={field.borderRight}
            borderTop={field.borderTop}
        />
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                isCalculated={field.isCalculated}
                isCalculatedNew={field.isCalculatedNew}
                handleChange={changeHandler}
                readOnly={field.readOnly || isFormReadOnly}
                labelWidth={field.labelWidth}
                width={field.width}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                direction={field.direction}
                padding={field.padding}
                type={field.type}
                marginBottom={field.marginBotom}
                maxLength={field.maxLength}
                borderRight={field.borderRight}
                borderTop={field.borderTop}
                borderBottom={field.borderBottom}
                textAlign={field.textAlign}
                userRole={userRole}
                isDisabled={field.isDisabled}
                height={field.height}
                hasDPSError={field.hasDPSError}
                marginTop={field.marginTop}
                textAlignLabel={field.textAlignLabel}
                borderLeft={field.borderLeft}
                isLabelNew={field.isLabelNew}
            />
        );
    const dropdownInput = (field) => field.isDropdown ? (
        <StyleFailureNewDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                labelWidth={field.labelWidth}
                width={field.width}
                isDisabled={field.isDisabled}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                readOnly={isFormReadOnly || field.readOnly}
                direction={field.direction}
                textAlign={field.textAlign}
                borderTop={field.borderTop}
                borderRight={field.borderRight}
                inputTextAlign={field.inputTextAlign}
                marginTop={field.marginTop}
                marginBottom={field.marginBottom}
                noDefaultOption={field.noDefaultOption}
            />
        </StyleFailureNewDropdown>
    )
        : multiDrop(field);
    return (
        <div>
            {
                selectFailureModeSectionData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabelTab
                                            formName={formName}
                                        >
                                            <StyledLabel
                                                id={field.key}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                color={field.color}
                                                fontSize={field.fontSize}
                                                fontStyle={field.fontStyle}
                                                marginTop={field.marginTop}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        </StyledLabelTab>
                                    )
                                    : dropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </div>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FailureModeSection);

FailureModeSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
